import { createAction, props } from '@ngrx/store';
import { SessionData } from 'src/app/user/session.service';

export const loginOk = createAction('[RootSession] Login Ok', props<{username: string}>());

export const fetchSession = createAction('[Session] Fetch Session');

export const fetchSessionSuccess = createAction(
  '[Session] Fetch Session Success',
  props<{ sessionData: SessionData }>()
);

export const fetchSessionFailure = createAction(
  '[Session] Fetch Session Failure',
  props<{ error: any }>()
);
